module.exports = __webpack_public_path__ + "db205265bff3ea334316fc89cf2cd862.png";